<template>
  <MainLayout>
    <div class="fill-height pa-2">
      <div class="card fill-height">
        <Map>
          <ComplaintsModule />

          <ZoomControl position="topleft" />
          <CurrentLocationControl position="topleft" />
          <HomeControl position="topleft" />

          <ScaleBarControl position="bottomleft" />

          <LayersControl position="bottomleft" legends-control-position="topleft">
            <PrintMapControl position="topright" />
          </LayersControl>

          <UtilityViewerModule :current-utility="currentUtility" :utilities="utilities" position="topright" />

          <UtilityPointControl v-model="utilities" :current-utility.sync="currentUtility" position="topright" />

          <UtilityQueryControl position="topright" @apply-query="onApplyQuery" @reset="onQueryReset"
            @pan-to-point="onPanToPoint" />
        </Map>
      </div>
    </div>
  </MainLayout>
</template>

<script>
import Map from "@/components/Map/Map";
import ZoomControl from "@/components/Map/modules/ZoomControl/ZoomControl";
import LayersControl from "@/components/Map/modules/LayersControl/LayersControl";
import PrintMapControl from "@/components/Map/modules/PrintMapControl/PrintMapControl";
import HomeControl from "@/components/Map/modules/HomeControl/HomeControl";
import ScaleBarControl from "@/components/Map/modules/ScaleBarControl/ScaleBarControl";
import CurrentLocationControl from "@/components/Map/modules/CurrentLocationControl/CurrentLocationControl";
import UtilityQueryControl from "@/components/Map/modules/UtilityQueryControl/UtilityQueryControl";

import ComplaintsModule from "./ComplaintsModule";

import UtilityPointControl from "./UtilityPointControl";
import UtilityViewerModule from "@/components/UtilityPoint/UtilityViewerModule";

export default {
  metaInfo: {
    title: "Dashboard",
    meta: [{ name: "Dashboard", content: "home, dashboard page" }]
  },

  components: {
    Map,
    ZoomControl,
    LayersControl,
    PrintMapControl,
    CurrentLocationControl,
    HomeControl,
    ScaleBarControl,
    UtilityQueryControl,
    ComplaintsModule,

    UtilityPointControl,
    UtilityViewerModule
  },

  data() {
    return {
      utilities: [],
      currentUtility: null
    };
  },

  methods: {
    onApplyQuery({ utilities }) {
      this.utilities = utilities;
    },

    onQueryReset({ utilities }) {
      this.utilities = utilities;
      this.currentUtility = null;
    },
    onPanToPoint(utilities) {
      this.currentUtility = utilities;
    },

  }
};
</script>
